import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'kd-document-anchor',
    templateUrl: './document-anchor.component.html',
    styleUrls: ['./document-anchor.component.scss']
})
export class DocumentAnchorComponent implements OnInit {

    @Input()
    id: string;

    url: string;

    constructor() { }

    ngOnInit() {
        this.url = `${location.origin}${location.pathname}`;
    }
}
